/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
 */
/**
 * Mapper for the Table static element
 *
 * We use a blockTree, so we need to wrap the content into a `<table>` element. The DomParser of the blockTreeBuilder
 * consider the HTML as invalid if sub-table elements (caption, tbody, etc.) aren't inside a `<table>`.
 * (Need to use blockTree because table can contain other elements (images, interactions, etc.) and links (they will have `target` attribute appended))
 *
 */
export default {
    /**
     * Map the table element, wrap the body into a table
     * @param {Object} element - the table element
     * @returns {object} the mapped element
     */
    mapElement(element) {
        if (element && element.body && element.body.body) {
            const htmlBody = `<table>${element.body.body}</table>`;
            const elemBody = Object.assign({}, element.body, { body: htmlBody });
            const mappedElement = Object.assign({}, element, { body: elemBody });
            return mappedElement;
        }
        return element;
    },

    /**
     * If the element body has been wrapped, we need to only unwrap the blockTree
     * @param {Object} properties - Math block properties
     * @returns {Object} mapped properties
     */
    mapProperties(properties) {
        if (
            properties.blockTree &&
            properties.blockTree.length === 1 &&
            properties.blockTree[0].content === 'table' &&
            properties.blockTree[0].children.length
        ) {
            properties.blockTree = properties.blockTree[0].children;
        }
        return properties;
    }
};
